module.exports = __webpack_public_path__ + "static/media/River1.cc872767.jpeg";